import React from 'react';
import ModalFrame from '../../ModalFrame';
import ShowScoreReport from './ShowScoreReport';

class ModalShowScoreReportController extends React.Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);

  }


  hideModal() {
    const {setModalInfo} = this.props;
    setModalInfo({});
  }

  render() {
    const {modalInfo, confirmHandler} = this.props;
    return (
      <div className="example-modal">
        {modalInfo.name === 'reportTranscript' ?
          <ModalFrame
            title="ASSESSMENTS"
            desktopWidth="80%"
            headerCloseButtonHandler={this.hideModal}
            hasHeader={true}>
            <ShowScoreReport
              modalInfo={modalInfo}
              hideModal={this.hideModal}
              confirmHandler={confirmHandler}
            />
          </ModalFrame> : null}
      </div>
    )
  }
}

export default ModalShowScoreReportController;